<template>
  <div class="layer-tem">
    <!-- 关闭按钮 -->
    <img 
        :src="newClose"
        class="close-btn" 
        alt=""
        @click="closeLayer"
    >
    <!-- 下拉框 -->
    <div class="select-wrap">
        <Select 
            v-model="areaId"
            transfer 
            :word-wrap="true"
            clearable
            style="width: 100px;margin-right: 10px;"
            placeholder="全部区域"
            @on-change="formChange"
        >
            <Option
            v-for="item in areaArr"
            :value="item.sid"
            :key="item.id">
            {{ item.name }}
            </Option>
        </Select>
        <Select 
            v-model="industId"
            transfer 
            :word-wrap="true"
            clearable
            style="width: 100px;"
            placeholder="全部行业"
            @on-change="formChange"
        >
            <Option
            v-for="item in industArr"
            :value="item.value"
            :key="item.id">
            {{ item.name }}
            </Option>
        </Select>
    </div>
    <!-- 标题 -->
    <div class="tit">
        联网单位分布
    </div>
    <!-- 列表 滚动加载更多 -->
    <div class="table-wrap">
        <div class="table-head">
            <table>
                <tr>
                    <th width="5%">
                        序号
                    </th>
                    <th width="25%">
                        单位名称
                    </th>
                    <th width="10%">
                        所属区域
                    </th>
                    <th width="10%">
                        单位类别
                    </th>
                    <th width="25%">
                        单位地址
                    </th>
                    <th width="10%">
                        消防负责人
                    </th>
                    <th width="10%">
                        联系方式
                    </th>
                    <th width="10%">
                        详情
                    </th>
                </tr>
            </table>
        </div>
        <div class="table-body" id="rightTop">
            <table>
                <tr v-for="(item, index) in tableList" :key="index">
                    <td width="5%">
                        {{index+1}}
                    </td>
                    <td width="25%" >
                        <Poptip
                            trigger="hover"
                            transfer :word-wrap="true"
                            :content="item.name"
                            v-if="item.name"
                        >
                            {{item.name}}
                        </Poptip>
                    </td>
                    <td width="10%" >
                        <Poptip
                            trigger="hover"
                            transfer :word-wrap="true"
                            :content="item.areaName"
                            v-if="item.areaName"
                        >
                            {{item.areaName}}
                        </Poptip>
                    </td>
                    <td width="10%" >
                        <Poptip
                            trigger="hover"
                            transfer :word-wrap="true"
                            :content="item.industryCategoryName"
                            v-if="item.industryCategoryName"
                        >
                            {{item.industryCategoryName}}
                        </Poptip>
                    </td>
                    <td width="25%" >
                        <Poptip
                            trigger="hover"
                            transfer :word-wrap="true"
                            :content="item.address"
                            v-if="item.address"
                        >
                            {{item.address}}
                        </Poptip>
                    </td>
                    <td width="10%" >
                        <Poptip
                            trigger="hover"
                            transfer :word-wrap="true"
                            :content="item.leader"
                            v-if="item.leader"
                        >
                            {{item.leader}}
                        </Poptip>
                    </td>
                    <td width="10%" >
                        <Poptip
                            trigger="hover"
                            transfer :word-wrap="true"
                            :content="item.leaderPhone"
                            v-if="item.leaderPhone"
                        >
                            {{item.leaderPhone}}
                        </Poptip>
                    </td>
                    <td width="10%" >
                       <span class="viewDetail" @click="showDetailLayer(item.id,item)">查看</span>
                    </td>
                </tr>
            </table>
            <p class="no-data" v-show="!tableList.length && getTableStatus">
                暂无数据
            </p>
        </div>
    </div>
    <span class="tipTotal">单位数量：{{totalCount}}</span>
  </div>
</template>
<script>
import newClose from '@/assets/img/newClose.png';
export default {
  name:"",    
  data: () => ({
    newClose,
    industArr: [],
    industId: '',
    areaArr: [],
    areaId: '',
    getTableStatus: false,
    tableList: [],
    totalCount: '',
    currentPage: 1,
    hashValue: '',
    notIndustryCategory:null,
    loginData: {},
    isFirst:true
  }),
  components: {

  },
  created() {
    this.hashValue = localStorage.getItem('hashValue');
    this.loginData = JSON.parse(localStorage.getItem('loginData'));
    this.getAreaData();
    this.getIndustData();
  },
  mounted() {
    // this.getTable();
  },
  computed: {

  },
  methods: {
    showDetailLayer(id, item){ //显示详情弹窗
      this.$store.commit('baseInfoLayer', {
        detailStatus: true,
        baseInfoId: id,
        baseInfoItem: item
      });
    },
    closeLayer(){
      this.$store.commit('showLayer', {
          status: false,
          type: '',
      });
    },
    formChange(){
        this.tableList = [];
        this.totalCount = '';
        this.currentPage = 1;
        this.isFirst = false
        this.getTable();
    },
    getAreaData(){
      let dataObj = {
            type: 'get',
            // url: '/mcbw/areas/' + this.loginData.orgId,
            url: '/mcbw/departments/org/area',
            obj: {
              pageSize: 1000,
              currentPage: 1,
            }
        }
        this.$Axios(dataObj).then((res)=>{
            console.log(res);
            console.log('区域数据');
            if(res.data.success && res.data.data.length){
              this.areaArr = res.data.data;
            }
        });
    },
    getIndustData(){
      let dataObj = {
            type: 'get',
            url: '/mcbw/dictionary_datas/industryCategory/data',
            obj: {
            }
        }
        this.$Axios(dataObj).then((res)=>{
            console.log(res);
            console.log('行业数据');

            if(res.data.success && res.data.data.length){
                var clickName = this.$store.state.showLayer.navIndex
                if(clickName == '其他'){
                    this.notIndustryCategory = this.$store.state.notIndustryCategory
                }
                for(var key of res.data.data){
                    if(key.name == clickName){
                        this.industId = key.value
                    }
                }
                this.getTable()
              this.industArr = res.data.data;
            }
        });
    },
    getTable(){
        this.getTableStatus = false;
        let obj= {
            monitorId: this.loginData.orgId,
            areaSid: this.areaId || '',
            industryCategory: this.industId || null,
            currentPage: this.currentPage,
            pageSize: 50,
        }
        if(this.isFirst){
            if(this.$store.state.showLayer.navIndex == '未联网' || this.$store.state.showLayer.navIndex == '已联网'){
                obj.onlineState = this.$store.state.showLayer.navIndex == '未联网' ? 0 : 1
            }else{
                if(this.notIndustryCategory){ //点击的其他
                    obj.notIndustryCategory = this.notIndustryCategory
                    delete obj.industryCategory
                }else{
                    obj.industryCategory = this.industId
                }
            }
        }
        
        let dataObj = {
            type: 'get',
            url: '/mcbw/departments/owner',
            obj
        }
        this.$Axios(dataObj).then((res)=>{
            console.log(res);
            console.log('表格详情');
            this.getTableStatus = true;
            if(res.data.success){
                if(res.data.totalCount){
                    this.totalCount = res.data.totalCount;
                }
                if(!res.data.data.length){
                    return;
                }
                this.tableList = [...this.tableList, ...res.data.data];
                let _this = this;
                this.$nextTick(()=>{
                    $JQ('#rightTop').mCustomScrollbar({
                        callbacks: {
                            onTotalScroll: function () {
                                if ((_this.tableList.length == res.data.totalCount) || (res.data.data.length == 0)) {
                                    console.log('没有更多数据');
                                    return;
                                } else {
                                    console.log('加载更多');
                                    _this.currentPage += 1;
                                    _this.getTable();
                                }
                            }
                        }
                    });
                });
            }
        });
    }
  }
}
</script>
<style lang="scss" scoped>
.tipTotal{
    position: absolute;
    right: 35px;
    top: 74px;
    font-size: 15px;
    color: #74D9FF;
}
.layer-tem{
    position: absolute;
    left: 500px;
    bottom: 0;
    width: calc(100% - 1000px);
    padding: 30px 25px;
    background: rgba(6,18,44,1) url('../../assets/img/maskBg.png') center center/101% 102% no-repeat;
    border-radius: 4px;
    z-index: 12;
    // 关闭按钮
    .close-btn{
        position: absolute;
        right: 0;
        top: 0;
        right: 15px;
        top: 15px;
        cursor: pointer;
    }
    .select-wrap{
        
    }
    .tit{
        margin: 10px 0;
        width: 200px;
    }
    .table-wrap{
        height: 400px;
        display: flex;
        flex-direction: column;
        .table-head{
            background: #0C2745;
            color: #7DB4DB;
            table th{
                height: 30px;
            }
        }
        .table-body{
            flex: 1;
            flex-shrink: 0;
            overflow: hidden;
            color: #E4EFF5;
            /deep/ .mCSB_scrollTools{
                right: 0!important;
                .mCSB_dragger{
                    background: rgba(255,255,255,.3);
                    border-radius: 8px;
                    .mCSB_dragger_bar{
                        width: 8px;
                    }
                }
                .mCSB_draggerRail{
                    background-color: transparent;
                }
            } 
            table td{
                text-align: center;
                height: 30px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                i{
                cursor: pointer;
                }
                i.imgView {
                    color: rgba(8, 244, 247, .7);
                    cursor: pointer;
                    &.active {
                        color: rgba(8, 244, 247, .3);
                        cursor: default;
                    }
                }
                .td-option-wrap {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    i {
                        margin: 0 10px;
                        color: rgba(8, 244, 247, .3);
                        cursor: default;
                        &.active {
                            color: rgba(8, 244, 247, .7);
                            cursor: pointer;
                        }
                    }
                }
            }
            table tr:nth-child(2n){
              background: #0C2745;
            }
            .no-data{
                height: 368px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #ddd;
            }
        }

        table{
            width: 100%;
            table-layout: fixed;
            border-collapse: collapse;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/layer/rightTop.vue